
      // Register or unregister the Service Worker based on Vite env at build time
      // This runs in both dev and prod because it's part of the HTML template.
      const enableSW = import.meta.env?.VITE_ENABLE_SW === 'true';
      if ('serviceWorker' in navigator) {
        if (enableSW) {
          window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js')
              .then((registration) => {
                console.log('SW registered: ', registration);
              })
              .catch((err) => {
                console.log('SW registration failed: ', err);
              });
          });
        } else {
          // Ensure any previously-registered SW is removed when disabled
          navigator.serviceWorker.getRegistrations().then((regs) => {
            regs.forEach((reg) => {
              console.log('Unregistering service worker:', reg.scope);
              reg.unregister();
            });
          });
          // Best-effort: clear app-namespaced caches to avoid stale HTML/assets
          if ('caches' in window) {
            caches.keys().then((names) => {
              names.forEach((name) => {
                if (name.includes('billportal')) {
                  caches.delete(name);
                }
              });
            });
          }
        }
      }
    